import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { fetchPayouts, fetchPendingPayouts } from '../../app-main/actions/payouts';
import PaidPayoutsTable from './PaidPayoutsTable';
import PendingPayoutsTable from './PendingPayoutsTable';
import { PaginationBtn } from '../../elements-buttons/pagination-button';
import { Spinner } from 'shared-components/decorators/spinner';
import { push } from 'react-router-redux';
import { toggleModal } from '../../app-main/actions/modal';
import { FormattedMessage } from 'react-intl';

class PayoutsMain extends React.Component {
  constructor (props) {
    super(props);

    this.fetchPayouts = this.fetchPayouts.bind(this);
    this.fetchPendingPayouts = this.fetchPendingPayouts.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount () {
    const { dispatch } = this.props;

    dispatch(this.fetchPayouts())
      .then(dispatch(this.fetchPendingPayouts('&count=5')));
  }

  componentDidUpdate (prevProps) {
    const { dispatch } = this.props;
    const page = parseInt(get(this.props, 'location.query.p', 0), 10);
    const prevPage = parseInt(get(prevProps, 'location.query.p', 0), 10);

    if (prevPage !== page) {
      dispatch(this.fetchPayouts());
    }
  }

  fetchPayouts () {
    const ssoId = get(this.props, 'profile.data.SSOid', '');
    const token = get(this.props, 'auth.accessToken', '');
    const page = parseInt(get(this.props, 'location.query.p', 0), 10);
    const query = page ? `?offset=${(page - 1) * 20}` : '';

    return fetchPayouts(ssoId, token, query);
  }

  fetchPendingPayouts (query) {
    const ssoId = get(this.props, 'profile.data.SSOid', '');
    const token = get(this.props, 'auth.accessToken', '');

    return fetchPendingPayouts(ssoId, token, query);
  }

  toggleModal (modalId, modalData) {
    this.props.dispatch(toggleModal({ modalId, modalData }));
  }

  render () {
    const totalPayouts = get(this.props, 'payouts.data.total', 0);
    const totalPendingPayouts = get(this.props, 'payouts.pendingPayoutsData.total', 0);
    const payouts = get(this.props, 'payouts.data.results', []);
    const pendingPayouts = get(this.props, 'payouts.pendingPayoutsData.results', []);
    const page = parseInt(get(this.props, 'location.query.p', 0), 10);
    const isFetching = get(this.props, 'payouts.isFetching', false);
    const hasFetched = get(this.props, 'payouts.hasFetched', false);
    const pendingHasFetched = get(this.props, 'payouts.pendingHasFetched', false);

    if (isFetching) {
      return (
        <div className="spinner-container">
          <Spinner additionalStyle="gray" />
        </div>
      );
    }

    if (hasFetched && pendingHasFetched && (!payouts.length && !pendingPayouts.length)) {
      return (
        <div className="payouts-empty text-gray-600 bg-gray-100 text-center">
          <FormattedMessage
            id="hosting.payouts_main.no_payouts_message"
            defaultMessage="There are no payouts to show yet"
          />
        </div>
      );
    }

    return (
      <div className="payouts margin-xl-top">
        {
          0 < pendingPayouts.length && (2 > page) &&
          <PendingPayoutsTable
            {...this.props}
            payouts={pendingPayouts}
            total={totalPendingPayouts}
            fetchPendingPayouts={this.fetchPendingPayouts}
          />
        }
        {
          0 < payouts.length &&
          <div>
            <PaidPayoutsTable
              {...this.props}
              payouts={payouts}
              toggleModal={this.toggleModal}
            />
            <PaginationBtn
              first
              last
              page={page || 1}
              maxButtons={4}
              paginate={({ eventKey }) => this.props.dispatch(push(`/account/payouts?p=${eventKey}`))}
              limit={20}
              pageCount={payouts.length}
              totalCount={totalPayouts}
            />
          </div>
        }
      </div>
    );
  }
}


function mapStateToProps (state) {
  const {
    auth,
    profile,
    payouts,
    modal
  } = state;

  return {
    auth,
    profile,
    payouts,
    modal
  };
}

PayoutsMain.propTypes = {
  dispatch: PropTypes.func.isRequired
};

export default connect(mapStateToProps)(PayoutsMain);
